module.exports = require("react-markdown");


//////////////////
// WEBPACK FOOTER
// external "react-markdown"
// module id = 164
// module chunks = 0